import {AbstractUaService, UaType} from './abstract-ua-service';
import {Injectable} from '@angular/core';
import {ApiService} from './api';

@Injectable({providedIn: 'root'})
export class UtaService extends AbstractUaService {
  constructor(protected apiService: ApiService) {
    super(apiService);
    this.init(UaType.UTA);
  }
}
